module.exports = __webpack_public_path__ + "media/images/lb/630-ec742f60bd30352e286b773f5e6935d3.svg";